import script from "./OSAgriculturaDash.vue?vue&type=script&setup=true&lang=js"
export * from "./OSAgriculturaDash.vue?vue&type=script&setup=true&lang=js"

import "./OSAgriculturaDash.vue?vue&type=style&index=0&id=58509a17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58509a17"]])

export default __exports__